import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Layout for every page under /settings. Sub-navigation lives in the left
 * nav (see StaffSettingsNav), so the shell only provides the page frame.
 */
export default function SettingsShell() {
  const { t } = useTranslation();

  return (
    <div className="p-8 space-y-8">
      <p className="text-sm font-semibold text-cs-gray-500">
        {t('staff_settings.title')}
      </p>
      <Outlet />
    </div>
  );
}
